import { createContext, useContext } from 'react';

const PostTripConnectContext = createContext(null);

export const usePostTripConnect = () => {
  const context = useContext(PostTripConnectContext);
  if (!context) {
    throw new Error('usePostTripConnect must be used within a PostTripConnectProvider');
  }
  return context;
};

export default PostTripConnectContext;
